import PropTypes from "prop-types";
import * as React from "react";
import { Radio, Typography } from "../../themeV2";
import styles from "./AddShopDialog.module.css";
import { ACTION } from "./addShopReducer";

const SHOP_TYPES = [
  { value: "Talent", description: "Sets user as talent" },
  { value: "Agent", description: "Sets user as agent" },
  { value: "Artist", description: "Sets user as artist" },
  { value: "Other", description: "No user type flag set" },
];

function ShopTypeSection({ shopType, dispatch }) {
  return (
    <section className={styles.section}>
      <Typography variant="title-md" as="h3">
        Shop type
      </Typography>

      <Typography variant="label-md" color="variant">
        Determines which user flag is set on the shop owner
      </Typography>

      <Radio.Group
        className={styles.shopTypeGrid}
        value={shopType}
        onValueChange={(value) =>
          dispatch({
            type: ACTION.SET_FIELD,
            field: "shopType",
            value,
          })
        }
      >
        {SHOP_TYPES.map(({ value, description }) => (
          <Radio.Item
            key={value}
            value={value}
            label={`${value} (${description})`}
          />
        ))}
      </Radio.Group>
    </section>
  );
}

ShopTypeSection.propTypes = {
  shopType: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default React.memo(ShopTypeSection);
